export const Mode = {
  PRIMARY: 'primary',
  CRITICAL: 'critical',
  SECONDARY: 'secondary',
  GRAY: 'gray',
  WHITE: 'white',
} as const;

export type Mode = Union<typeof Mode>;

export const Size = {
  SMALL: 's',
  LARGE: 'l',
} as const;

export type Size = Union<typeof Size>;
